
<template>
    <div>
        <div class="flex w-full">
            <div class="w-1/6 mr-4">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by Fixed Date</label>
                    <multiselect :options="dateRanges"
                                 v-model="selectedFixedDateRangeIdentifier"
                                 :show-labels="false"
                                 @input="setFixedDateRange(selectedFixedDateRangeIdentifier)"
                                 @remove="clearDates"
                                 track-by="id" label="name" class="mb-2 cursor-pointer">
                    </multiselect>
                </div>
            </div>
            <div class="w-1/4 mr-4">
                <div>
                    <label class="text-sm text-grey-darkest">Dates</label>
                    <div class="input-group mb-3">
                        <div class="input-group-prepend">
                            <span class="input-group-text text-sm cursor-pointer hover:bg-grey hover:text-white text-grey-darkest"  @click="openDateRangePickerButton"><i class="fa fa-calendar" aria-hidden="true"></i></span>
                        </div>
                        <input type="text" ref="daterange"
                               :value="selectedDateRange ? selectedDateRange.start  +' - '+ selectedDateRange.end : ''"
                               class="form-control" @focus="openDateRangePicker"
                               :class="(requiredFields && requiredFields.start_date) ? 'required-field-color' : '' || (requiredFields && requiredFields.end_date) ? 'required-field-color' : '' "/>
                        <div class="input-group-append">
                            <span class="input-group-text cursor-pointer hover:bg-grey hover:text-white text-grey-darkest">
                                <i class="material-icons text-sm" @click.stop="clearDates">clear</i>
                            </span>
                        </div>
                    </div>
                    <div class="text-red text-xs" v-if="(requiredFields && requiredFields.start_date)">{{
                        requiredFields.start_date}}
                    </div>
                    <div class="text-red text-xs" v-if="(requiredFields && requiredFields.end_date)">{{
                        requiredFields.end_date}}
                    </div>
                </div>
            </div>
            <div v-if="!isPm" class="w-1/6 mr-4">
                <label class="text-sm text-grey-darkest">Filter by User</label>
                <multiselect v-if="tabName== 'general'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else-if="tabName== 'master'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else-if="tabName== 'sale'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else-if="tabName== 'products'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else-if="tabName== 'client'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else-if="tabName== 'contract'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else-if="tabName== 'computerEase'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else-if="tabName== 'foundation'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else-if="tabName== 'quotes'" class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" :multiple="true"></multiselect>
                <multiselect v-else class="cursor-pointer" :options="usersOptions" v-model="selectedUser" :show-labels="false" :class="(requiredFields && requiredFields.user) ? 'has-error' : ''"
                             track-by="id" label="name" ></multiselect>

                <div class="text-red text-xs" v-if="(requiredFields && requiredFields.user)">{{
                        requiredFields.user
                    }}
                </div>
            </div>
            <div v-if="isPm" class="w-1/6 mr-4">
                <label class="text-sm text-grey-darkest">Filter by Stage</label>
                <multiselect class="cursor-pointer" :options="stagesOptions" v-model="selectedStage" :show-labels="false"
                             track-by="id" label="short_description"></multiselect>
            </div>
            <div class="w-1/6 mr-4">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by {{ getFieldLabel(fieldLabels, 'office') }}</label>
                    <multiselect
                        :options="offices"
                        v-model="selectedOffices"
                        :show-labels="false"
                        @remove="selectedOffice = null"
                        track-by="id"
                        label="code"
                        group-values="group"
                        group-label="code"
                        :group-select="true"
                        class="mb-2 cursor-pointer"
                        :multiple="true"
                    >
                    </multiselect>
                </div>
            </div>
            <div class="w-1/6 mr-4" id="contract-type-filter">
                <div>
                    <label class="text-sm text-grey-darkest">Filter by {{ getFieldLabel(fieldLabels, 'contract-type') }}</label>
                    <multiselect v-if="tabName== 'general'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else-if="tabName == 'master'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else-if="tabName == 'sale'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else-if="tabName == 'products'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else-if="tabName == 'client'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else-if="tabName == 'contract'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else-if="tabName == 'foundation'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else-if="tabName == 'quotes'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else-if="tabName == 'computerEase'" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true" class="mb-2 cursor-pointer" :multiple="true">
                    </multiselect>
                    <multiselect v-else class="mb-2 cursor-pointer" :options="contractTypes"
                                 v-model="selectedContractType"
                                 :show-labels="false"
                                 track-by="id" label="code" group-values="group"
                                 group-label="code"
                                 :group-select="true">
                    </multiselect>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Mixin from './mixin';

    import Datepicker  from 'vuejs-datepicker';
    import Multiselect from 'vue-multiselect';
    import moment      from 'moment';
    import 'daterangepicker/daterangepicker.css';
    import 'daterangepicker';
    // import 'v-calendar/lib/v-calendar.min.css';

    export default {
        mixins    : [Mixin],
        name      : 'report-filter',
        components: {Datepicker, Multiselect},
        props     : [
            'tabName',
            'user',
            'users',
            'dateRange',
            'office',
            'contractType',
            'fixedDateRangeIdentifier',
            'isPm',
            'projectStages',
            'masks',
            'userIds',
            'userRole',
            'fieldLabels'
        ],
        data() {
            return {
                rangeMask: {
                    input: this.masks.moment_mask,
                },
                usersOptions                    : [],
                stagesOptions                   : [],
                // selectedUser                    : this.user ? this.user : null,
                selectedUser                    : [],
                selectedStage                    : null,
                selectedDateRange               : this.dateRange ? {
                    start: moment(this.dateRange.start).format('MM/DD/YYYY'),
                    end  : moment(this.dateRange.end).format('MM/DD/YYYY')
                } : null,
                offices                         : [{
                    code: 'All',
                    group:[]
                }],
                selectedOffices                 : [],
                contractTypes                   : [
                    {
                    code: 'All',
                    group:[]
                }
                ],
                selectedContractType            : [],
                dateRanges                      : [],
                selectedFixedDateRangeIdentifier: this.fixedDateRangeIdentifier !== null ? this.fixedDateRangeIdentifier : null,
                requiredFields                  : null
            }
        },

        watch: {
            selectedUser() {
                if(this.selectedUser.length > 0 && this.requiredFields && this.requiredFields.user) {
                    this.requiredFields.user = null
                }
                this.updateFilterUri();
            },

            selectedOffices() {
                this.updateFilterUri();
            },

            selectedContractType() {
                this.updateFilterUri();
            },

            selectedDateRange(){
                if(this.selectedDateRange && this.requiredFields) {
                    this.requiredFields.start_date = null
                    this.requiredFields.end_date = null
                }
            },
            selectedFixedDateRangeIdentifier() {
                if(this.selectedFixedDateRangeIdentifier && this.requiredFields) {
                    this.requiredFields.start_date = null
                    this.requiredFields.end_date = null
                }
                this.updateFilterUri();
            },

            selectedStage() {
                this.updateFilterUri();
            },
        },

        created() {
            this.usersOptions = this.users;
            this.stagesOptions = this.projectStages;
            this.getContractTypes();
            this.getOffices();
            this.fetchData();
            this.updateFilterUri();
        },
        mounted() {
            let self = this;
            Bus.$on('filterFieldsRequired', data => {
                self.requiredFields = data;
            });
        },

        methods: {
            openDateRangePicker() {
                $(this.$refs.daterange).daterangepicker({
                    opens: 'center',
                    autoApply: true,
                    showDropdowns: true,
                    locale: {
                        format: 'MM/DD/YYYY'
                    }
                }, (start, end, label) => {
                    this.selectedFixedDateRangeIdentifier = null;
                    this.selectedDateRange                = {
                        start: moment(start).format('MM/DD/YYYY'),
                        end  : moment(end).format('MM/DD/YYYY')
                    }
                    this.updateFilterUri();
                });
            },
            openDateRangePickerButton() {
                this.$nextTick(() => {
                    this.$refs.daterange.focus();
                });
            },
            selectedDateRangeChanged() {
                this.selectedFixedDateRangeIdentifier = null;
                this.updateFilterUri();
            },

            fetchData() {
                let self = this;
                axios.get(route('date-ranges')).then((data) => {
                    self.dateRanges = data.data.dateRanges;
                    let allUsers = data.data.users;

                    if(!self.userIds) {
                        self.selectedUser = self.users.filter((element)=>{
                            return self.user.id === element.id;
                        });
                    }else{
                        if(self.userIds.length === 1 && self.userIds[0] === 0){
                            self.selectedUser = [{
                                id: 0,
                                name: 'Company'
                            }]
                        }else{
                            self.selectedUser = self.users.filter((element)=>{
                                return self.userIds.find((aux)=> aux === element.id);
                            });
                        }
                    }

                });
            },

            clearDates() {
                this.selectedDateRange = null;
                this.updateFilterUri();
            },
            getOffices() {
                let self = this;
                axios.get(route('api.settings.codes.office.index')).then((response) => {
                    self.offices[0].group = response.data;
                    let office = JSON.parse(this.office);
                    if(office) {
                        self.selectedOffices = self.offices[0].group.filter((element)=>{
                            return office.find((aux)=> aux === element.id);
                        })
                    }
                });
            },
            getContractTypes() {
                let self = this;
                axios.get(route('api.settings.codes.contract-type.index')).then((response) => {
                    self.contractTypes[0].group = response.data;
                    // self.contractTypes.unshift({id: 0, code: 'All'});
                    let contract = JSON.parse(this.contractType);
                    // if (contract != undefined) {
                    //     self.selectedContractType = _.find(self.contractTypes, function (o) {
                    //         return o.id === Number(contract);
                    //     })
                    // }
                    if(contract) {
                        self.selectedContractType = self.contractTypes[0].group.filter((element)=>{
                            return contract.find((aux)=> aux === element.id);
                        })
                    }
                });
            },

            updateFilterUri() {
                this.getFilter();
                this.$emit('updated-filter', this.uri);
            },
            setFixedDateRange(dateRange) {
                if (!dateRange) return;
                this.selectedFixedDateRangeIdentifier = this.dateRanges[dateRange.id];
                if(dateRange.id > 0)
                    this.selectedDateRange                = {
                        start: moment(this.dateRanges[dateRange.id].startDate).format('MM/DD/YYYY'),
                        end  : moment(this.dateRanges[dateRange.id].endDate).format('MM/DD/YYYY')
                    };
                this.updateFilterUri();
            },
            maxDate() {
                return moment().add(1, 'y').toDate();
            },
            formatDateRange(){
                if(!this.selectedDateRange)
                    return '';

                let dates = this.selectedDateRange;
                return `${moment(dates.start).format(this.masks.moment_mask)} - ${moment(dates.end).format(this.masks.moment_mask)}`;
            },
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
    .daterangepicker td.active, .daterangepicker td.active:hover {
        background-color: #01b1af !important;
        border-color: transparent !important;
        color: #fff !important;
    }
    .daterangepicker .ranges li.active {
        background-color: #73DEDEFF !important;
        color: #fff !important;
    }
    .has-error .multiselect__tags {
        border: 1px solid #e3342f !important;
    }
</style>
